import { createSelector } from 'reselect';
import { getContentModelId, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import ContentRoutes from 'ContentUtils/Routes';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
// @ts-expect-error no declarations found for module
import { getPreviewDomain } from 'ContentEditorUI/redux/selectors/iframesSelectors';
import { getAttribute } from 'ContentEditorUI/redux/selectors/userAttributesSelectors';
import { getSubject, getFromName, getReplyTo, createMaskedAddressSelector
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/redux/selectors/EditSelectors';
import { CURRENT_USER_ATTRIBUTES } from 'EmailEditorUI/constants/UserAttributesForEditor';
const getPreviewData = basicSelector(state => state.previewData);
const createPreviewDataSelector = property => createSelector(getPreviewData, state => state[property]);
const createRenderedPreviewDataSelector = property => createSelector(getPreviewData, state => {
  const {
    renderedEmail
  } = state;
  if (Object.keys(renderedEmail).length > 0) {
    return renderedEmail[property].output;
  }
  return '';
});
export const getCurrentNonPreviewPane = createPreviewDataSelector('currentNonPreviewPane');
export const getPreviewContact = createPreviewDataSelector('selectedContact');
export const getPreviewProductIds = createPreviewDataSelector('productIds');
export const getPlatformOpen = createPreviewDataSelector('platformOpen');
export const getRenderedEmail = createPreviewDataSelector('renderedEmail');
export const getPreviewEstimatedSize = createPreviewDataSelector('estimatedSize');
export const getIsPreviewDataLoading = createPreviewDataSelector('isPreviewDataLoading');
export const getPreviewFiltersConfig = createPreviewDataSelector('previewFiltersConfig');
export const getPreviewDataRequestParams = createPreviewDataSelector('previewDataRequestParams');
export const getIsAutomationTab = createSelector([getCurrentNonPreviewPane], currentNonPreviewPane => currentNonPreviewPane === 'automation');
const _getPreviewUrl = (previewDomain, previewKey, id, contact, productIds) => {
  const params = {
    preview_key: previewKey,
    hsPreviewerApp: 'email'
  };
  if (contact) {
    params.email = contact.email;
  }
  if (productIds && productIds.length > 0) {
    params.objectIds = productIds;
    params.objectTypeFqn = 'PRODUCT_TO_LINE_ITEM';
    params.contextKey = 'deal';
  }
  return ContentRoutes.getPreviewUrl(id, params, previewDomain);
};
export const getBasePreviewUrl = createSelector([getPreviewDomain, getPreviewKey, getContentModelId], _getPreviewUrl);
export const getPreviewUrl = createSelector([getPreviewDomain, getPreviewKey, getContentModelId, getPreviewContact, getPreviewProductIds], _getPreviewUrl);
const _getPreviewSubject = createRenderedPreviewDataSelector('subject');
const _getPreviewFromName = createRenderedPreviewDataSelector('fromName');
const _getPreviewReplyTo = createRenderedPreviewDataSelector('replyTo');
export const getPreviewPlainText = createRenderedPreviewDataSelector('plainText');
export const getPreviewHTMLOutput = createRenderedPreviewDataSelector('html');
export const getPreviewCrmCallCounts = createSelector(getRenderedEmail, renderedEmail => {
  if ('extraResultFields' in renderedEmail) {
    return renderedEmail.extraResultFields ? renderedEmail.extraResultFields.crmCallCounts : 0;
  }
  return 0;
});
export const getBlogRssPreviewType = createSelector(getRenderedEmail, renderedEmail => {
  var _renderedEmail$extraR;
  return (_renderedEmail$extraR = renderedEmail.extraResultFields) === null || _renderedEmail$extraR === void 0 ? void 0 : _renderedEmail$extraR.blogRssPreviewType;
});
const createFallbackSelector = (selector1, selector2) => createSelector([selector1, selector2], (res1, res2) => res1 || res2);
export const getPreviewSubject = createFallbackSelector(_getPreviewSubject, getSubject);
export const getPreviewFromName = createFallbackSelector(_getPreviewFromName, getFromName);
const getPreviewReplyTo = createFallbackSelector(_getPreviewReplyTo, getReplyTo);
export const getMaskedPreviewReplyTo = createMaskedAddressSelector(getPreviewReplyTo);
export const getHasDimissedOutlookPreviewBanner = state => getAttribute(state, CURRENT_USER_ATTRIBUTES.HAS_DISMISSED_OUTLOOK_PREVIEW_BANNER) === 'true';